<template>
  <profile-section
    section-title="Settings"
  >
    <div class="profile-list-section">
      <button
        v-for="id in disabledWidgets"
        :key="id"
        class="profile-btn"
        @click="enableWidget(id)"
      >
        {{ widgetName(id) }}
      </button>
      <button
        v-for="sim in resettableSims"
        :key="sim.id"
        class="profile-btn"
        :disabled="!!activeSection"
        @click="openModal('reset-sim-modal', { simConfig: sim })"
      >
        Reset {{ simulationName(sim) }}
      </button>
      <button
        class="profile-btn danger"
        :disabled="!!activeSection"
        @click="openModal('reset-modal')"
      >
        Reset All Progress
      </button>
    </div>
    <reset-modal
      @close-modal="closeModal"
      @reset-progress="resetProgress"
    />
    <reset-sim-modal
      @close-modal="closeModal"
      @reset-sim-progress="resetSimProgress"
    />
  </profile-section>
</template>

<script>
import ProfileSection from '@components/profile/section.vue';
import ResetModal from '@components/profile/modals/reset.vue';
import ResetSimModal from '@components/profile/modals/reset-sim.vue';
import WidgetMixin from '@/mixins/widget';

export default {
  name: 'SettingsProfileSection',
  components: { ProfileSection, ResetModal, ResetSimModal },
  mixins: [ WidgetMixin ],
  props: {
    activeSection: {
      type: String,
    },
  },
  computed: {
    resettableSims() {
      return this.$store.getters['simulationConfigs/all']
        .filter(config => this.isResettable(config.categoryId))
        .filter(config => this.$access(this.$store, 'category', config.categoryId));
    },
    disabledWidgets() {
      const ids = this.$store.getters['ui/disabledDashboards'];
      return ids;
    },
  },
  methods: {
    closeModal(name) {
      this.$modal.hide(name);
    },
    isResettable(categoryId) {
      const category = this.$store.getters['categories/categories'][categoryId];
      return category?.userResettable;
    },
    openModal(name, params = {}) {
      this.$modal.show(name, params);
    },
    resetProgress() {
      this.closeModal('reset-modal');
      this.$store.dispatch('session/resetProgress').then(_ => {
        this.$analytics.events.resetProgress({ status: 'Success' });
        this.$notify({
          group: 'notifications',
          text: 'Progress reset successfully',
          type: 'success',
        });
      }).catch(e => {
        this.$analytics.events.resetProgress({ status: 'Failure' });
        this.$notify({
          group: 'notifications',
          text: 'Unable to reset progress, please contact support',
          type: 'error',
        });
      });
    },
    resetSimProgress(simConfig) {
      this.closeModal('reset-sim-modal');
      const category = this.$store.getters['categories/categories'][simConfig.categoryId];
      const analyticsParams = {
        simulationName: category?.name,
        simulationId: simConfig.categoryId,
      };
      this.$store.dispatch('simulationConfigs/resetSimulation', { categoryId: simConfig.categoryId }).then(_ => {
        analyticsParams.status = 'Success';
        this.$analytics.events.resetSimProgress(analyticsParams);
        this.$notify({
          group: 'notifications',
          text: 'Simulation reset successfully',
          type: 'success',
        });
        this.$store.commit('flashcardStates/deleteFlashcardStates', { type: 'Category', categoryId: simConfig.categoryId });
        this.$store.commit('categoryStates/deleteCategoryStates', simConfig.categoryId);
      }).catch(e => {
        analyticsParams.status = 'Failure';
        this.$analytics.events.resetSimProgress(analyticsParams);
        this.$notify({
          group: 'notifications',
          text: 'Unable to reset simulation, please contact support',
          type: 'error',
        });
      });

    },
    simulationName(simConfig) {
      const category = this.$store.getters['categories/categories'][simConfig.categoryId];
      return category?.name;
    },
  },
};
</script>

<style lang="scss" scoped>
  .profile-list-section {
    margin-left: auto;

    .profile-btn {
      color: #00d8f8;
      padding: 0;
      border-bottom: 1px solid transparent;
      background: transparent;
      display: block;
      margin-left: auto;

      &:not(:first-of-type) {
        margin-top: rem-calc(20);
      }

      &.danger {
        color: #ee1300;
      }

      &:disabled {
        opacity: .25;
      }

      &:hover:not(:disabled) {
        border-bottom: 1px solid #00d8f8;

        &.danger {
          border-bottom: 1px solid #ee1300;
        }
      }
    }
  }
</style>
